export default __webpack_public_path__ + "static/media/modelbg2.e4241367.png";